import { render } from "./icon-pulse-share-locked.svg?vue&type=template&id=606ddc87&scoped=true&component"
const script = {}

import "./icon-pulse-share-locked.svg?vue&type=style&index=0&id=606ddc87&scoped=true&lang=css&component"

import exportComponent from "../../../../../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-606ddc87"]])

export default __exports__